/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type DeleteAIConfigTriggerPathParams = NonNullable<operations['deleteAIConfigTrigger']['parameters']['path']>;

export type DeleteAIConfigTriggerQueryParams = NonNullable<operations['deleteAIConfigTrigger']['parameters']['query']>;

export interface Input extends DeleteAIConfigTriggerPathParams {
  apiVersion?: string;
  query: DeleteAIConfigTriggerQueryParams;
  header: NonNullable<operations['deleteAIConfigTrigger']['parameters']['header']>;
}

export async function deleteAIConfigTrigger(
  { apiVersion, query, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().DELETE('/api/v2/projects/{projectKey}/ai-configs/{configKey}/triggers/{triggerID}', {
    params: { path, query, header },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
